// Google Map Extension for React, React-Leaflet
import * as RadioGroup from "@radix-ui/react-radio-group";
import { useEffect } from "react"
import { useMap } from "react-leaflet"

// This is the google maps API key. You can get it from the Google Cloud Console.
export const GOOGLE_API_KEY = "AIzaSyAoJkDuvdUyHzqZxHnEIA_JjlnPBw-wCRw"

const MAP_IDS = {
  dark: "8914f89a8794e5e7",
  light: "d99756d81adee155",
}

const lightStyle: google.maps.MapTypeStyle[] = [
  {
    featureType: "all",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#EAF7F7",
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#B8DEDC",
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#3A6164",
      },
      {
        weight: 0.8,
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#FFFFFF",
      },
      {
        visibility: "on",
      },
      {
        weight: 3,
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#F5FAFA",
      },
    ],
  },
  {
    featureType: "landscape.natural",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#E6F2F2",
      },
    ],
  },
  {
    featureType: "poi",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#6D8F8F",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#C8E6C9",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#D3E9E8",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#C8E4E3",
      },
      {
        weight: 0.4,
      },
    ],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#2E5A64",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#FFFFFF",
      },
      {
        visibility: "on",
      },
      {
        weight: 3,
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#C0E1E0",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#A5D2D0",
      },
      {
        weight: 0.6,
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#2E5A64",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#FFFFFF",
      },
      {
        visibility: "on",
      },
      {
        weight: 3,
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#4C7373",
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#FFFFFF",
      },
      {
        visibility: "on",
      },
      {
        weight: 3,
      },
    ],
  },
  {
    featureType: "transit",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#D9F1F2",
      },
      {
        saturation: -10,
      },
      {
        lightness: 15,
      },
    ],
  },
]

const darkStyle: google.maps.MapTypeStyle[] = [
  {
    featureType: "all",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    elementType: "geometry",
    stylers: [
      {
        color: "#1d2c4d",
      },
    ],
  },
  {
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#8ec3b9",
      },
    ],
  },
  {
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#1a3646",
      },
    ],
  },
  {
    featureType: "administrative.country",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#4b6878",
      },
    ],
  },
  {
    featureType: "administrative.land_parcel",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#64779e",
      },
    ],
  },
  {
    featureType: "administrative.province",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#4b6878",
      },
    ],
  },
  {
    featureType: "landscape.man_made",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#334e87",
      },
    ],
  },
  {
    featureType: "landscape.natural",
    elementType: "geometry",
    stylers: [
      {
        color: "#023e58",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [
      {
        color: "#283d6a",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#6f9ba5",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#1d2c4d",
      },
    ],
  },
  {
    featureType: "poi.business",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#023e58",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#3C7680",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [
      {
        color: "#304a7d",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#98a5be",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#1d2c4d",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [
      {
        color: "#2c6675",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#255763",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#b0d5ce",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#023e58",
      },
    ],
  },
  {
    featureType: "transit",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#98a5be",
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#1d2c4d",
      },
    ],
  },
  {
    featureType: "transit.line",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#283d6a",
      },
    ],
  },
  {
    featureType: "transit.station",
    elementType: "geometry",
    stylers: [
      {
        color: "#3a4762",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#0e1626",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#4e6d70",
      },
    ],
  },
]

interface GoogleMapsLayerProps {
  theme?: "dark" | "light"
  mapType?: "roadmap" | "satellite" | "hybrid" | "terrain"
  onError: () => void
}

export function GoogleMapsLayer({ theme, mapType, onError }: GoogleMapsLayerProps) {
  const map = useMap()

  useEffect(() => {
    let googleLayer: L.GridLayer
    let script: HTMLScriptElement | null = null

    const initMap = () => {
      try {
        const container = map.getContainer()
        container.classList.remove("light-theme", "dark-theme")
        container.classList.add(`${theme}-theme`)

        googleLayer = L.gridLayer.googleMutant({
          type: mapType,
          maxZoom: 22,
          ...(mapType === "roadmap" || mapType === "terrain"
            ? {
                styles: theme === "dark" ? darkStyle : lightStyle,
                mapOptions: {
                  mapId: theme === "dark" ? MAP_IDS.dark : MAP_IDS.light,
                  disableDefaultUI: true,
                  styles: theme === "dark" ? darkStyle : lightStyle,
                },
              }
            : {}),
        })
        googleLayer.addTo(map)
        console.log("DEBUG>>>", googleLayer)
      } catch (err) {
        console.error("Google Maps initialization failed:", err)
        onError()
      }
    }

    if (!window.google) {
      script = document.createElement("script")
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&libraries=places`
      script.async = true
      script.defer = true
      script.onerror = () => console.error("Failed to load Google Maps script")

      const checkLoaded = () => {
        if (window.google) {
          initMap()
        } else {
          setTimeout(checkLoaded, 100)
        }
      }

      script.onload = checkLoaded
      document.head.appendChild(script)
    } else {
      initMap()
    }

    return () => {
      if (googleLayer) map.removeLayer(googleLayer)
      if (script && document.head.contains(script)) document.head.removeChild(script)
      const container = map.getContainer()
      container.classList.remove("light-theme", "dark-theme")
    }
  }, [map, mapType, theme])

  return null
}


const layerOptions = [
  {
    value: "roadmap",
    label: "Roadmap",
  },
  {
    value: "hybrid",
    label: "Satellite",
  },
];

export const RadioCardsLayer = ({
  setMapType,
}: { setMapType: (mapType: "roadmap" | "hybrid") => void }) => {
  return (
    <RadioGroup.Root
      defaultValue={layerOptions[0].value}
      onValueChange={(value) => setMapType(value as "roadmap" | "hybrid")}
      className="max-w-sm w-full grid grid-cols-3 gap-3 p-1"
    >
      {layerOptions.map((option) => (
        <RadioGroup.Item
          key={option.value}
          value={option.value}
          className="ring-[1px] ring-border rounded py-1 px-3 data-[state=checked]:ring-2 data-[state=checked]:ring-blue-500"
        >
          <span className="font-semibold tracking-tight">{option.label}</span>
        </RadioGroup.Item>
      ))}
    </RadioGroup.Root>
  );
};